import { useFormik } from "formik";
import React, { useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CourseService from "../../../services/KangarooServices/CourseService";
import toast from "react-hot-toast";

const CourseGroupForm = ({ isOpen, toggle, fetchGrp, selectedItem }) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedItem?.id || "",
      headingName: selectedItem?.headingName || "",
      orderIndex: selectedItem?.orderIndex ?? 0,
      description: selectedItem?.description || "",
    },

    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        if (values.id) {
          await CourseService.updateGrp(selectedItem?.id, values);
          toast.success("Course group updated successfully.");
        } else {
          await CourseService.createGrp(values);
          toast.success("Course group created successfully.");
        }

        fetchGrp();
        resetForm();
        toggle();
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Course Group</ModalHeader>

      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={12} className="mb-2">
              <Label>
                Heading Name <span className="text-danger">*</span>
              </Label>

              <Input
                name="headingName"
                value={formik.values.headingName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.headingName &&
                  Boolean(formik.errors.headingName)
                }
              />

              {formik.touched.headingName && formik.errors.headingName && (
                <div className="text-danger mt-1">
                  {formik.errors.headingName}
                </div>
              )}
            </Col>

            <Col md={12} className="mb-2">
              <Label>
                Order Index <span className="text-danger">*</span>
              </Label>

              <Input
                type="number"
                name="orderIndex"
                value={formik.values.orderIndex}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.orderIndex && Boolean(formik.errors.orderIndex)
                }
              />

              {formik.touched.orderIndex && formik.errors.orderIndex && (
                <div className="text-danger mt-1">
                  {formik.errors.orderIndex}
                </div>
              )}
            </Col>

            <Col md={12}>
              <FormGroup>
                <Label>Description</Label>

                <CKEditor
                  editor={ClassicEditor}
                  data={formik.values.description}
                  onChange={(event, editor) => {
                    formik.setFieldValue("description", editor.getData());
                  }}
                />
              </FormGroup>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-3 mt-3">
            <Button type="submit" color="success" disabled={loading}>
              {loading ? "Saving..." : formik.values.id ? "Update" : "Create"}
            </Button>

            <Button
              type="button"
              color="soft-danger"
              onClick={() => {
                formik.resetForm();
                toggle();
              }}
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default CourseGroupForm;
